import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import UPLOAD from "../../../../components/uoload/upload";
import { Col, Row } from "antd";
import SELECT from "./../../../../components/select/select";
import BUTTON from "./../../../../components/buttons/button";
import { color } from "./../../../../utils/themes/color";

export default function LifeStyleAthlete(props) {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    const trainingDays = [{ "name": "یک روز", "value": "یک روز" }, { "name": "دو روز", "value": "دو روز" }, { "name": "سه روز", "value": "سه روز" }, { "name": "چهار روز", "value": "چهار روز" }, { "name": "پنج روز", "value": "پنج روز" }, { "name": "شش روز", "value": "شش روز" }, { "name": "هفت روز", "value": "هفت روز" }]
    const [inactions, setInactions] = useState([]);
    const [sleepDurations, setSleepDurations] = useState([]);
    const [exerciseGoals, setExerciseGoals] = useState([]);
    const [jobTypes, setJobTypes] = useState([]);
    const [updater, setUpdater] = useState(1)


    useEffect(() => {
        Axios.get(`${url}users/v1/get-life-style-lists`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {

                    var x = [];
                    for (const iterator of response.data.jobTypes) {
                        x.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setJobTypes(x)

                    var t = [];
                    for (const iterator of response.data.exerciseGoals) {
                        t.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setExerciseGoals(t)

                    var a = [];
                    for (const iterator of response.data.sleepDurations) {
                        a.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setSleepDurations(a)

                    var u = [];
                    for (const iterator of response.data.inactions) {
                        u.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setInactions(u)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [])



    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}users/athlete-get-life-style/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setUser({
                        "sleepDuration": response.data.lifeStyle.sleepDuration != null && response.data.lifeStyle.sleepDuration != undefined ? response.data.lifeStyle.sleepDuration._id : "",
                        "exerciseGoal": response.data.lifeStyle.exerciseGoal != null && response.data.lifeStyle.exerciseGoal != undefined ? response.data.lifeStyle.exerciseGoal._id : "",
                        "inaction": response.data.lifeStyle.inaction != null && response.data.lifeStyle.inaction != undefined ? response.data.lifeStyle.inaction._id : "",
                        "jobType": response.data.lifeStyle.jobType != null && response.data.lifeStyle.jobType != undefined ? response.data.lifeStyle.jobType._id : "",
                        "trainingDays": response.data.lifeStyle.trainingDays != null && response.data.lifeStyle.trainingDays != undefined ? response.data.lifeStyle.trainingDays : null
                    })
                    setLoading(false)

                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log("er", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updater])



    const updateLifeStyle = () => {
        if (user.sleepDuration != "" && user.sleepDuration != null && user.sleepDuration != undefined 
        && user.exerciseGoal != "" && user.exerciseGoal != null && user.exerciseGoal != undefined
        && user.inaction != "" && user.inaction != null && user.inaction != undefined
        && user.jobType != "" && user.jobType != null && user.jobType != undefined
        && user.trainingDays != "" && user.trainingDays != null && user.trainingDays != undefined) {

        setLoading(true);
        var x = {
            "sleepDuration": user.sleepDuration,
            "exerciseGoal": user.exerciseGoal,
            "inaction": user.inaction,
            "jobType": user.jobType,
            "trainingDays": user.trainingDays
        }


        Axios.patch(`${url}users/athlete-life-style/${userId}`, x)
            .then(async (response) => {
                if (response.status === 200 || response.status === 201) {
                    GreenNotif(response.message);
                    setLoading(false);
                    setUpdater(updater + 1)
                    props.pager(4)
                } else {
                    RedNotif(response.message);
                    setLoading(false);
                }
            })
            .catch((error) => {
                RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                console.log("error", error)
                setLoading(false)
            });
        } else {
            RedNotif("هیچ کدام از موارد نمی تواند خالی باشد")
        }
    }


    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px', marginTop: "15px" }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>گزینه مناسب را انتخاب نمایید:</p>
                    </Col>
                </Row>
                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>اطلاعات شغلی:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "jobType": e })}
                            items={jobTypes}
                            value={user.jobType}

                        />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>وضعیت در حالت غیر کاری:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "inaction": e })}
                            items={inactions}
                            value={user.inaction}
                        />
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px', marginTop: "15px" }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>میزان خواب:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "sleepDuration": e })}
                            items={sleepDurations}
                            value={user.sleepDuration} />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>روز تمرین در هفته:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "trainingDays": e })}
                            items={trainingDays}
                            value={user.trainingDays} />
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px', marginTop: "15px" }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>هدف اصلی:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "exerciseGoal": e })}
                            items={exerciseGoals}
                            value={user.exerciseGoal} />
                    </Col>
                </Row>

                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => updateLifeStyle()} text="ثبت و بعدی" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(4)} text="رد کردن" type={"cancel"} />

                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }


}